export default __webpack_public_path__ + "static/media/preverified_disc.c4718929.png";